const getMenuLabel = (item, t) => {
    if (item && item.textKey) {
        return t(`sideNav.${item.textKey}`)
    }
    return item && item.text ? item.text : ''
}

const appendNavTitleItem = (items, conf) => {
    if (!conf) {
        return items
    }
    if (conf.textKey) {
        return [...items, { textKey: conf.textKey }]
    }
    if (conf.text) {
        return [...items, { literal: conf.text }]
    }
    return items
}

const resolveNavTitle = (titleItems, t) => {
    if (!titleItems || !titleItems.length) {
        return ''
    }
    return titleItems
        .map((item) => (item.textKey ? t(`sideNav.${item.textKey}`) : item.literal))
        .filter(Boolean)
        .join(' / ')
}

export { getMenuLabel, appendNavTitleItem, resolveNavTitle }
